/* eslint-disable default-param-last */
import { alteraCorSistema } from '@utils';
import { ALTERA_COR_SUCCESS } from './constants';

const initialState = {
  codCorPrincipal: undefined,
  nomeCorPrincipal: undefined,
  codCorHover: undefined,
  codCorFocus: undefined,
};

export default function customizaSistema(state = initialState, action) {
  switch (action.type) {
    case ALTERA_COR_SUCCESS:
      alteraCorSistema(
        action.values.geral,
        action.values.hover,
        action.values.focus
      );

      return {
        ...state,
        codCorPrincipal: action.values.geral,
        nomeCorPrincipal: action.values.nome,
        codCorHover: action.values.hover,
        codCorFocus: action.values.focus,
        codCorLaranja: '#e87400',
      };
    default:
      return {
        ...state,
      };
  }
}
